const VerificationStepperSteps = {
  INVALID_STEP: 0,
  EMAIL_VERIFICATION: 1,
  MEDICAL_PRACTITIONER_VERIFICATION: 2,
  VERIFICATION_COMPLETE: 3,
  LOGBOX_VERIFICATION: 3,
  LOGBOX_VERIFICATION_COMPLETE: 4,
}
export default VerificationStepperSteps
